
const initialState = {
    data_zona: null,
    is_loading: false,
    error: null
};

export default function zona(state=initialState, action){
    switch (action.type){
        case 'ZONA_LOADING':
            return { data_zona: null, is_loading: true, error: null};
        case 'ZONA_LOAD_SUCCESS':
            return {...state, data_zona: action.data, is_loading: false, error: null};
        case 'ZONA_LOAD_FAILED':
            return {...state, data_zona: null, is_loading: false, error: action.data};
        case 'INITIAL_DATA':
                return {...state, data_zona: null, is_loading: false, error: null};
        default:
            return state;

    }
}